module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg-e2bd749b488da2d63e8ca731b490278c.jpg";